import React, { Children, memo } from "react";
import Button from '@mui/material/Button';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ToggleButton from '@mui/material/ToggleButton';

export const UiButton = memo((props) => {
    const { variant, name, size, onClick, fullWidth,color, disabled } = props;
    return (
        <>
            <Button
                variant={variant}
                onClick={onClick}
                fullWidth={fullWidth}
                color={color}
                disabled={disabled}
                className="sba-mui-button"
                size={size}>
                {name}
            </Button>
        </>
    )

})

export const UiButtonDataManagement = memo((props) => {
    const { variant, name, size, onClick, fullWidth,color, disabled } = props;
    return (
        <>
            <Button
                variant={variant}
                onClick={onClick}
                fullWidth={fullWidth}
                color={color}
                disabled={disabled}
                className="sba-mui-lookup-button"
                size={size}>
                {name}
            </Button>
        </>
    )

})

export const UiButtonPrimary = memo((props) => {
    const { variant, name, size, onClick, fullWidth } = props;
    return (
        <>
            <Button
                variant={variant}
                onClick={onClick}
                fullWidth={fullWidth}
                className="sba-mui-button-primary"
                size={size}>
                {name}
            </Button>
        </>
    )

})
export const UiIconButton = memo((props) => {
    const { variant, name, size, onClick, fullWidth, icon } = props;
    return (
        <>
            <Button 
                variant={variant} 
                startIcon={icon} 
                onClick={onClick}
                fullWidth={fullWidth} 
                className="sbt-icon-button"
                size={size}>
                {name}
            </Button>


        </>
    )

})

export const UiBackButton = memo((props) => {
    const {  size, onClick, fullWidth, disabled } = props;
    return (
        <>
        <div className='sbt-back-button__wr'>
            <Button
                variant="outlined"
                onClick={onClick}
                fullWidth={fullWidth}
                disabled={disabled}
                className="sba-mui-button"
                size={size}>
                <ArrowBackIosIcon/>Back
            </Button>
        </div>
            
        </>
    )

})

export const UiToggleButton = memo((props) => {
    const {  icon , onClick, name,children} = props;
    const [selected, setSelected] = React.useState(false);
    return (
        <>
            <ToggleButton
                value="check"
                selected={selected}
                onChange={() => {
                    setSelected(!selected);
                }}
                onClick={onClick}
                className="sbt-toggle-btn"
                >{children}
            </ToggleButton>            
        </>
    )

})

